import { paygEndpoints } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';
import { useQuery, UseQueryOptions } from 'react-query';
import { paygQueryKeys } from './queryKeys';
import { PendingTopup, TopupResponse } from './types';

type Params = Omit<
  UseQueryOptions<
    TopupResponse<'topups', PendingTopup[]>,
    unknown,
    PendingTopup[],
    ReturnType<typeof paygQueryKeys.pendingTopups>
  >,
  'queryKey' | 'queryFn' | 'select'
>;

export const usePendingTopups = ({
  enabled = true,
  ...options
}: Params = {}) => {
  const { accountId } = useAccountContext();

  return useQuery({
    retry: 1,
    ...options,
    enabled: enabled && !!accountId,
    queryKey: paygQueryKeys.pendingTopups(accountId || ''),
    queryFn: () =>
      apiService.get<TopupResponse<'topups', PendingTopup[]>>({
        url: paygEndpoints.pendingTopups(accountId!),
      }),
    select: ({ topups }) => topups,
  });
};
